import { createStore } from "redux";
import reducers from './reducers/index';
import { persistStore } from 'redux-persist';

//the empty bracket is the preloaded state/initial state
export const store = createStore(
    reducers, {},
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store)

// export {store, persistor};








// import { createStore } from "redux";
// import reducers from './reducers/index';

// //the empty bracket is the preloaded state/initial state
// const store = createStore(
//     reducers, {},
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );


// export default store;